// Update this version when we do API changes that could cause issues with the
// frontend for users who have an old version of the website open in a tab.
// This variable is imported by the frontend and sent with all API requests
// in a "X-API-Version" custom header.
// Ideally we want something more automatic for this than a manually updated
// variable. We could perhaps rely on Zod schemas more if the Hono client
// could parse expected data it receives, which it currently does not.
export const API_VERSION = "1";
